<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Software Development</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Software Development</li>
            </ul>
        </div>
    </div>
</div>

<section class="space">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="page-single">
                    <div class="service-img sv-details-img">
                        <img class="w-100" src="assets/img/service/development.webp"
                            alt="Software Development" />
                    </div>
                    <div class="page-content sv-content d-block">
                        <h2 class="box-title">Software Development</h2>
                        <p class="box-text mb-30">The development process of web application development involves the
                            implementation and coding of the design and functionality defined during the planning and
                            design phases. It includes various steps and activities to build the web application
                            according to the specified requirements.
                        </p>
                        <div class="sv-gallery-wrapper">
                            <h2 class="box-title">Why Web Deployment Important?</h2>
                            <div class="row gy-4">
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/video-image-1.jpg.webp" alt="" />
                                    </div>
                                </div>
                                <div class="col-6 my-5">
                                    <p>Here are the key steps involved in the deployment process:</p>
                                    <div class="checklist tick-checklist sv-details-list mb-40">
                                        <ul class="list">
                                            <li>Setting up the development environment</li>
                                            <li>Front-end development</li>
                                            <li>Back-end development</li>
                                            <li>Database design and development</li>
                                            <li>Integration and APIs</li>
                                            <li>Testing &amp; Reviews</li>
                                            <li>Deployment</li>
                                            <li>Maintenance and updates</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row gy-4">
                                <div class="col-12">
                                    <p>The development process requires collaboration between front-end developers,
                                        back-end developers, database administrators, and other team members to ensure
                                        the successful implementation of the web application. By following a structured
                                        development process, teams can build robust, scalable, and efficient web
                                        applications that meet the desired requirements.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-service-sidebar></app-service-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>